import { IFeature } from 'static/interfaces'

type AreaFeatureLite = Pick<IFeature, 'id' | 'slug' | 'title'>

interface IResolveSearchAreaFeatureArgs {
  currentFeatureSlug?: string | null
  currentFeatureType?: string | null
  pathname: string
  parsedAreaFeatures: IFeature[]
  searchFiltersAreaFeature: AreaFeatureLite | null
}

const findAreaFeatureBySlug = (areaFeatures: IFeature[], slug: string | null): IFeature | null => {
  if (!slug) {
    return null
  }

  return areaFeatures.find(feature => feature.slug === slug) ?? null
}

export const resolveInitialSearchAreaFeature = ({
  currentFeatureSlug,
  currentFeatureType,
  pathname,
  parsedAreaFeatures,
  searchFiltersAreaFeature,
}: IResolveSearchAreaFeatureArgs): IFeature | null => {
  const normalizedPathname = pathname.replace(/\/+$/, '') || '/'

  // トップページでは常に area 絞り込みを外す。
  if (normalizedPathname === '/') {
    return null
  }

  const areaFromCookie = findAreaFeatureBySlug(
    parsedAreaFeatures,
    searchFiltersAreaFeature?.slug ?? null
  )
  const isFeaturesPage = normalizedPathname.startsWith('/features/')

  if (!isFeaturesPage) {
    return areaFromCookie
  }

  // feature_type が area 以外の feature ページでは area 絞り込みを外す。
  if (currentFeatureType && currentFeatureType !== 'area') {
    return null
  }

  const slugFromPath =
    normalizedPathname
      .split('/')
      .filter(Boolean)
      .pop() ?? null
  const currentAreaSlug = currentFeatureSlug ?? slugFromPath
  const areaFromCurrentPage = findAreaFeatureBySlug(parsedAreaFeatures, currentAreaSlug)

  // area feature ページでは遷移先 area を優先して反映する。
  if (areaFromCurrentPage) {
    return areaFromCurrentPage
  }

  return areaFromCookie
}
